module.exports = __webpack_public_path__ + "img/emoji_69.a290fc10.png";